import React from 'react';
import WidgetPost from './widget/WidgetPost';
import WidgetCategory from './widget/WidgetCategory';

const BlogSidebar = ({activeCategory}) => {
    return (
        <div className="axil-sidebar">
            <div className="widget widget-categories">
                <h4 className="widget-title">Categories</h4>
                <WidgetCategory activeCategory={activeCategory} />
            </div>
            <div className="widget widget-recent-post">
                <h4 className="widget-title">Recent post</h4>
                <WidgetPost />
            </div>
        </div>
    )
}

export default BlogSidebar;